<svelte:options accessors/>
<script lang="ts">
    import ValidateForm from "../validate/ValidateForm.svelte";

    export let data = [];
</script>
<div>
    <section class="pb-1">
        <div class="container max-w-900px mx-auto">
            <p>Agrega o elimina tus vehículos ya sea por placa, referencia o número de orden y encuentra todo o que
                necesitas</p>
            <div class="mt-2">
                {#each data as vehicle (vehicle)}
                    <div class="border p-15 box-b mb-1">
                        <p>{vehicle}</p>
                        <div>
                            <div class="box-l sx-ii">
                                <img height="20" src="/static/storefront/pix/icons/eliminar.svg" alt="Eliminar vehículo">
                                <div class="underlined">Eliminar</div>
                            </div>
                        </div>
                    </div>
                {:else}
                    <p>No hay vehículo validado</p>
                {/each}
            </div>
        </div>
    </section>
    <hr>
    <section class="py-2">
        <div class="container max-w-900px mx-auto">
            <ValidateForm/>
        </div>
    </section>
</div>
